import { useTheme } from '../../hooks/useTheme';

// Components
import HeaderBar from '../../components/HeaderBar';
import ContentInfo from '../../components/ContentInfo';

// MUI imports
import { Box, Skeleton, useMediaQuery } from '@mui/material';

const SessionSkeleton = () => {
    const theme = useTheme();
    const smallScreen = useMediaQuery('(max-height:700px)');

    return (
        <Box
            sx={{
                width: '100%',
                height: '100vh',
                alignItems: 'center',
                backgroundColor: theme.palette.background.default,
                color: theme.palette.text.primary
            }}
        >
            <HeaderBar />

            <Box sx={{ display: 'flex', flexDirection: 'column', margin: '0 auto', width: '100%', height: '92.5%' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '92.5%', margin: '0 auto' }}>
                    <ContentInfo margin="0.5em 0 0.3em 0" padding="0.5em 0">
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '92.5%',
                                height: smallScreen ? '22vh' : '16vh'
                            }}
                        >
                            <Box sx={{ display: 'flex', flexDirection: 'column', width: 'auto', height: '100%' }}>
                                <Skeleton variant="text" width={200} height={30} sx={{ padding: '1.5em 0', marginBottom: '0.5em' }} />
                                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', width: 'auto' }}>
                                    <Skeleton variant="text" width={150} height={20} />
                                    <Skeleton variant="text" width={150} height={20} />
                                    <Skeleton variant="text" width={100} height={20} />
                                </Box>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', alignItems: 'center', width: 'auto', height: '100%' }}>
                                <Skeleton variant="rectangular" width={70} height={70} />
                                <Skeleton variant="text" width={70} height={30} />
                            </Box>
                        </Box>
                    </ContentInfo>
                </Box>
                <Box sx={{ display: 'flex', gap: '17.5px', width: '100%', margin: '1.5em 0 0.5em 1.2em' }}>
                    {[...Array(7)].map((_, index) => (
                        <Box
                            key={index}
                            sx={{
                                padding: '2px 0 0 0',
                                mb: '0.4em',
                                borderRadius: '5px',
                                width: '45px',
                                height: '50px',
                                boxShadow: '0px 3px 7px 0px rgba(0,0,0,0.15)'
                            }}
                        >
                            <Skeleton variant="text" sx={{ margin: '0 auto', width: '70%', height: '20px' }} />
                            <Skeleton variant="text" sx={{ margin: '0 auto', width: '60%', height: '30px' }} />
                        </Box>
                    ))}
                </Box>
                <Box
                    sx={{
                        position: 'relative',
                        display: 'flex',
                        justifyContent: 'space-evenly',
                        backgroundColor: theme.palette.background.default,
                        boxShadow: theme.palette.mode === 'light' ? '0px 3px 7px 0px rgba(0,0,0,0.15)' : 'none',
                        borderRadius: '10px',
                        width: '92.5%',
                        margin: '0 auto 0.1em auto',
                        height: '60px'
                    }}
                >
                    {[...Array(2)].map((_, index) => (
                        <Skeleton
                            key={index}
                            variant="rectangular"
                            sx={{
                                borderRadius: '10px',
                                padding: '8px 16px',
                                width: '40%',
                                height: '30%',
                                margin: 'auto 0'
                            }}
                        />
                    ))}
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', width: '100%', height: '100%' }}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-around',
                            alignItems: 'center',
                            width: '92.5%',
                            height: '45%',
                            maxHeight: '24vh',
                            marginTop: '0.25em'
                        }}
                    >
                        {[...Array(3)].map((_, index) => (
                            <Skeleton key={index} variant="rectangular" width="100%" height={50} sx={{ marginTop: '0.5em', borderRadius: '10px' }} />
                        ))}
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '92.5%',
                            marginBottom: '3em'
                        }}
                    >
                        <Skeleton variant="rectangular" width="60%" height={40} sx={{ borderRadius: '10px' }} />
                        <Skeleton variant="rectangular" width="15%" height={40} sx={{ borderRadius: '10px' }} />
                        <Skeleton variant="rectangular" width="15%" height={40} sx={{ borderRadius: '10px' }} />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default SessionSkeleton;
